import script from "./ModalMapsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMapsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalMapsComponent.vue?vue&type=style&index=0&id=067aa022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-067aa022"]])

export default __exports__